<template>
    <div class="GSC_main" :style="mainColors">
        <div class="container">
            <section class="page-section">
                <div class="row">
                    <div class="col">
                        <GreenLabel :title="'WHY CHOOSE US'" :color="'var(--main-color)'"/>
                    </div>
                </div>
                <WhiteBlock
                    :title="'Made by a team of researchers, analysts, dedicated to making the financial world  more inviting.'"
                    :description="whiteBlockDescription"
                    :img="'./img/coppa-1.png'" />

                <div class="row mutual" style="margin-top: 0; padding-top: 50px">
                    <div class="col-12">
                        <h2>{{ app_name }} is here to connect you directly with US Lenders in our dynamic Platform.</h2>
                        <p style="margin-top: 0">
                            Simply complete a safe and secure online loan request form to be connected with lenders in our network. Once we pass your information, these lenders may potentially offer your funds. Our online process is simple and can be completed usually within five minutes, which means you may connect with our network of lenders easily online.
                        </p>
                        <div class="btn-container" >
                            <GetStartedButton :text="'Check If I Qualify'"/>
                        </div>
                    </div>

                    <div class="delimiter"></div>

                    <div class="col-md-6 mt-5">
                        <h2>We help you connect to lenders fast with our simple online loan request form. </h2>
                        <p>{{ app_name }} is committed to bringing consumers and lenders together through our easy to use online loan request form. Within minutes of submitting your information, you may be connected to a lender in our network for loan offers. You are encouraged to carefully review any lender offer and information provided by each lender and are free to accept at your discretion.</p>
                    </div>

                    <div class="col-md-6 image-container">

                        <!-- <img :src="'./img/navigate-1.png'" /> -->
                    </div>

                </div>
            </section>
        </div>
        <div class="container-fluid">
            <section class="page-section p-0">
                <BrownBlock />
            </section>
        </div>
    </div>
</template>

<script>

import GreenLabel from "../components/GreenLabel.vue"
import WhiteBlock from "../components/WhiteBlock.vue"
import BrownBlock from "../components/BrownBlock.vue"
import GetStartedButton from "./GetStartedButton.vue";

export default {
    name: "WhyChooseUs",
    components: {
        GreenLabel,
        WhiteBlock,
        BrownBlock,
        GetStartedButton
    },
    data() {
        return {
            app_name: document.querySelector('title').text,
            mainColor: themeSettings.general.main_color.value,
        };
    },
    computed: {
        mainColors() {
            return {
                '--main-color': this.mainColor,
            };
        },
        whiteBlockDescription() {
            return `${this.app_name} was created to simplify and improve the process of learning about and finding personal loan options. By connecting readers to the top lenders in our network, we've made ${this.app_name}™ the one-stop-shop for all your personal loan needs.`;
        },
    },
    mounted() {
        this.app_name =  document.querySelector('title').text
        this.mainColor = themeSettings.general.main_color.value
    },
    methods: {
        getMetaContent(name) {
            const element = document.querySelector(`meta[name="${name}"]`);
            return element && element.content ? element.content : '';
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../sass/pages.scss";
</style>
